export const queryKeys = {
  accountActivation: 'accountActivation',
  holdsAndCheckoutsPage: 'holdsAndCheckoutsPage',
  projects: 'projects',
  projectDetails: 'projectDetails',
  userItemStatuses: 'userItemStatuses',
  savedInstancesCompact: 'savedInstancesCompact',
  savedSearches: 'savedSearches',
  validateUser: 'validateUser',
  createAccount: 'createAccount',
  availability: 'availability',
  ILLLinks: 'ILLLinks',
};

export interface PlaceHoldDto {
  requestId: string;
  item: { instanceId: string; itemId: string; title: string };
  requestDate: string;
  status: string;
  pickupLocationId: string;
  queuePosition: number;
}

export interface HoldActionErrorDto {
  response: { data: string | { errorMessage: string } };
}
